export default __webpack_public_path__ + "static/media/icon-user-access-active.49bfcf18.svg";